import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface GatewayList {
  name: string
  description: string
  ip: string
  port: string
  communication_status: string
}
export interface GatewayListState {
  isLoading: boolean
  loadingError: string | null
  gatewayList: GatewayList[] | null
  gatewayCount: number
  httpStatus: number | null
}

const initialState: GatewayListState = {
  isLoading: true,
  loadingError: null,
  gatewayList: null,
  gatewayCount: 0,
  httpStatus: null
}

const gatewayListSlice = createSlice({
  name: 'gatewayManagementGatewayList',
  initialState,
  reducers: {
    gatewayListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        gatewayList: null,
        gatewayCount: 0,
        httpStatus: 0
      }
    },
    gatewayListUpdateAction: (state, action: PayloadAction<{ data: GatewayList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        gatewayList: action.payload.data,
        gatewayCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    gatewayListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        gatewayList: null,
        gatewayCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  gatewayListLoadingAction,
  gatewayListUpdateAction,
  gatewayListErrorAction
} = gatewayListSlice.actions

export default gatewayListSlice.reducer
